import { useState } from "react";

interface TherapistPhotoProps {
  name: string;
  src?: string;
  className?: string;
  style?: React.CSSProperties;
}

// Keep replaced portraits on an explicit, versioned URL so clients that cached
// the previous files under the preserved filenames request the current assets.
// to the provided PNG without transforming the underlying image.
const portraitPaths: Record<string, string> = {
  "Jeika Matthew": "/images/team/Jeika-Matthew.png?v=20260910",
  "Maddie Lula": "/images/team/Maddie-Lula.png?v=20260910",
  "Neyla Sassi": "/images/team/Neyla-Sassi.png?v=20260910",
};

const publicPortraitPathFor = (name: string) =>
  portraitPaths[name.trim()] ||
  `/images/team/${name.trim().replace(/\s+/g, "-")}.png`;

export default function TherapistPhoto({
  name,
  src,
  className = "",
  style,
}: TherapistPhotoProps) {
  const [failed, setFailed] = useState(false);
  const resolvedSrc = src || publicPortraitPathFor(name);
  const initials = name
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  if (failed) {
    return (
      <div
        role="img"
        aria-label={`${name} photo unavailable`}
        className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-[#EEE8DA] to-[#DDD3F4] ${className}`}
      >
        <span className="font-fraunces text-4xl font-medium tracking-wide text-[#5D4B78]">
          {initials}
        </span>
      </div>
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt={name}
      className={className}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}
